// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__xyOy8","rotate":"loader_rotate__OigP1","prixClipFix":"loader_prixClipFix__3z9Yr"};